import DepartementList from './departmentList';
export default DepartementList;